import React, { Component } from "react";
import PropTypes from "prop-types";

import { Toast, StorageHandler } from "C4";
import { storageKeys } from "settings";

const leadingZero = (number) => `0${number}`.slice(-2);

export default class FlipBoard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      leftNumber: 0,
      rightNumber: 0,
      currentNumber: null,
      answerStyle: false,
      toastContent: null,
      headerImage: "",
    };
  }

  componentDidMount() {
    this.matchStep();
    this.setHeader();
  }

  async setHeader() {
    // Load profile image image
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ headerImage: questionHeader });
  }

  getCurrentNumber(parsed) {
    const { leftNumber, rightNumber } = this.state;
    if (parsed) {
      return parseInt(`${leftNumber}${rightNumber}`, 10);
    }
    return `${leftNumber}${rightNumber}`;
  }

  matchStep(e) {
    const { steps } = this.props;
    const { currentNumber } = this.state;

    if (steps !== undefined && currentNumber === null) {
      const leftNumber = leadingZero(steps[0])[0];
      const rightNumber = leadingZero(steps[0])[1];
      this.setState({
        leftNumber,
        rightNumber,
        currentNumber: 0,
      });
      return true;
    }

    if (
      e !== undefined &&
      e.target.id === "plus" &&
      steps !== undefined &&
      currentNumber < steps.length - 1
    ) {
      this.setState({
        currentNumber: currentNumber + 1,
        leftNumber: leadingZero(steps[currentNumber + 1])[0],
        rightNumber: leadingZero(steps[currentNumber + 1])[1],
      });
      return true;
    }

    if (
      e !== undefined &&
      e.target.id === "minus" &&
      steps !== undefined &&
      currentNumber > 0
    ) {
      this.setState({
        currentNumber: currentNumber - 1,
        leftNumber: leadingZero(steps[currentNumber - 1])[0],
        rightNumber: leadingZero(steps[currentNumber - 1])[1],
      });
      return true;
    }

    return false;
  }

  checkAnswer() {
    const {
      correctAnswer,
      contentComplete,
      correctAnswerText,
      incorrectAnswerText,
      error,
    } = this.props;

    if (correctAnswer === `${this.getCurrentNumber(true)}`) {
      this.setState({
        answerStyle: true,
        toastContent: {
          position: "top-center",
          content: correctAnswerText,
        },
      });
      contentComplete();
    } else {
      error(true);
      // this.setState({
      //   answerStyle: false,
      //   toastContent: {
      //     type: 'error',
      //     position: 'top-center',
      //     content: incorrectAnswerText,
      //   },
      // });
    }
  }

  render() {
    const { leftNumber, rightNumber, toastContent, headerImage } = this.state;
    const { question, disableHeader, error, disableToast } = this.props;
    return (
      <div className="container__question">
        {!disableHeader && (
          <div
            className="container__question--image"
            style={{ backgroundImage: `url(${headerImage})` }}
          />
        )}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="flipBoard__container">
            <div className="flipBoard">
              <button
                id="plus"
                onClick={(e) => {
                  this.matchStep(e);
                }}
                className="flipButton plus"
              />
              <button
                id="minus"
                onClick={(e) => {
                  this.matchStep(e);
                }}
                className="flipButton minus"
              />
            </div>
            <div className="flipNumbers">
              <div className="number left">{leftNumber}</div>
              <div className="number right">{rightNumber}</div>
            </div>
          </div>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          <button
            onClick={() => {
              this.checkAnswer();
            }}
            style={
              this.state.answerStyle ? { backgroundColor: "#6cd488" } : null
            }
          >
            Submit
          </button>
        </div>
        {error(false)}
      </div>
    );
  }
}

FlipBoard.propTypes = {
  contentComplete: PropTypes.func.isRequired,
  correctAnswer: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.number),
};

FlipBoard.defaultProps = {
  correctAnswerText: "",
  disableHeader: false,
  disableToast: false,
  error: () => {},
  incorrectAnswerText: "",
  steps: [],
};
